import {
  admSignupInfoProps,
  loginProps,
  signupProps,
  signupInfoProps,
  userInfoProps,
  manageSignupInfoProps,
  userStatusProps,
  searchMemberListProps,
  findPwdProps,
} from "interface/member";
import api from "./api";

export const loginApi = async (params: loginProps) => {
  const { memType, ...param } = params;
  const res = await api({
    method: "post",
    url: `${memType}/login`,
    data: param,
  });

  return res;
};

export const signupAdminInfoApi = async (params: admSignupInfoProps) => {
  const res = await api({
    method: "post",
    url: "admin/join/administrator",
    data: params,
  });

  return res;
};

export const signupManageInfoApi = async (params: manageSignupInfoProps) => {
  const res = await api({
    method: "post",
    url: "manager/join/apply",
    data: params,
  });

  return res;
};

export const authMailApi = async (url: string) => {
  const res = await api({
    method: "get",
    url,
  });

  return res;
};

export const signupApi = async (params: { data: signupProps; url: string }) => {
  const { data, url } = params;
  const res = await api({
    method: "post",
    url,
    data,
  });

  return res;
};

export const checkPwdApi = async (params: {
  emlId: string;
  lgnPwd: string;
}) => {
  const res = await api({
    method: "post",
    url: "manager/lgnPwdChk",
    data: params,
  });

  return res;
};

export const lodGrpListApi = async () => {
  const res = await api({
    method: "get",
    url: "manager/join/lodGrpList",
  });

  return res;
};

export const admListApi = async (params: any) => {
  const res = await api({
    method: "post",
    url: "admin/manage/admList",
    data: params,
  });

  return res;
};

export const admInfoApi = async (admNo: string) => {
  const res = await api({
    method: "get",
    url: `admin/manage/admDtl/${admNo}`,
  });

  return res;
};

export const modifyAdmInfoApi = async (params: userInfoProps) => {
  const res = await api({
    method: "post",
    url: "admin/manage/admInfo/modify",
    data: params,
  });

  return res;
};

export const managerListApi = async (
  params: Partial<searchMemberListProps>
) => {
  const res = await api({
    method: "post",
    url: "manager/manManage/manList",
    data: params,
  });
  return res;
};

export const managerInfoApi = async (manNo: string) => {
  const res = await api({
    method: "get",
    url: `manager/manManage/manDtlInfo/${manNo}`,
  });

  return res;
};

export const modifyManagerApi = async (params: userInfoProps) => {
  const res = await api({
    method: "post",
    url: `manager/manManage/manInfoModify`,
    data: params,
  });

  return res;
};

export const userInfoApi = async (params: string) => {
  const res = await api({
    method: "get",
    url: `admin/manage/admDtl/${params}`,
  });

  return res;
};

export const modifyUserStatusApi = async (params: userStatusProps) => {
  const res = await api({
    method: "post",
    url: "admin/manage/admJoin/approval",
    data: params,
  });

  return res;
};

export const dropUserApi = async (params: { check: boolean }) => {
  const res = await api({
    method: "post",
    url: "",
    data: params,
  });

  return res;
};

export const logOutApi = async (memType: string) => {
  const res = await api({
    method: "get",
    url: `${memType}/logout`,
  });
  return res;
};

export const findPindApi = async (params: findPwdProps) => {
  const res = await api({
    method: "post",
    url: "manager/lgnPwdReset",
    data: params,
  });

  return res;
};

export const certLgnPwdApi = async (params: {
  certEncParam: string;
  newLgnPwd: string;
}) => {
  const res = await api({
    method: "post",
    url: `manager/manCertLgnPwd`,
    data: params,
  });

  return res;
};

export const findPwdAuthMailApi = async () => {
  const res = await api({
    method: "get",
    url: ``,
  });

  return res;
};

export const chkMemApi = async (params: { pwd: string }) => {
  const res = await api({
    method: "post",
    url: ``,
    data: params,
  });

  return res;
};
